import {
  IntlProvider,
  LocalizationProvider,
  load,
  loadMessages,
} from "@progress/kendo-react-intl";
import "alertifyjs/build/css/alertify.min.css";
import "bootstrap/dist/css/bootstrap.min.css";
import React from "react";
import "react-confirm-alert/src/react-confirm-alert.css";
import ReactDOM from "react-dom/client";
import "../node_modules/font-awesome/css/font-awesome.min.css";
import App from "./App";
import "./css/adminlte.min.css";
import "./css/fontawesome-free/css/all.min.css";
import "./css/index.css";
import "@progress/kendo-theme-material/dist/all.css";
import "./index.css";
import reportWebVitals from "./reportWebVitals";

import axios from "axios";

import currencyData from "cldr-core/supplemental/currencyData.json";
import likelySubtags from "cldr-core/supplemental/likelySubtags.json";
import weekData from "cldr-core/supplemental/weekData.json";
import timeZoneNamesEn from "cldr-dates-full/main/en/timeZoneNames.json";
import caGregorian from "cldr-dates-full/main/tr/ca-gregorian.json";
import dateFields from "cldr-dates-full/main/tr/dateFields.json";
import timeZoneNamesTr from "cldr-dates-full/main/tr/timeZoneNames.json";
import currenciesEn from "cldr-numbers-full/main/en/currencies.json";
import numbersEn from "cldr-numbers-full/main/en/numbers.json";
import currenciesTr from "cldr-numbers-full/main/tr/currencies.json";
import numbersTr from "cldr-numbers-full/main/tr/numbers.json";

import i18next from "i18next";
import "../node_modules/font-awesome/css/font-awesome.min.css";
import translationEN from "../src/i18n/en.json";
import translationTR from "../src/i18n/tr.json";
import "./assets/styles/index.css";
import "./config/languageInit";
import i18n from "./config/languageInit";
import { authorizationToken } from "./helpers/authorizationToken";
import { API_GATEWAY, PR_DEP } from "./config/globalVariables";

load(
  likelySubtags,
  currencyData,
  weekData,
  caGregorian,
  dateFields,
  currenciesTr,
  timeZoneNamesTr,
  numbersTr,
  timeZoneNamesEn,
  currenciesEn,
  numbersEn
);

loadMessages(translationEN, "en");
loadMessages(translationTR, "tr");
const jwtToken = localStorage.getItem("jwtToken");

if (jwtToken) {
  authorizationToken(jwtToken);
}
document.documentElement.lang = i18n.language;
const root = ReactDOM.createRoot(document.getElementById("root"));
axios.defaults.headers.common["Accept-Language"] = i18n.language;
axios.defaults.baseURL = `${API_GATEWAY}${PR_DEP}`;
root.render(
  <LocalizationProvider language={i18next.language}>
    <IntlProvider locale={i18next.language}>
      <App />
    </IntlProvider>
  </LocalizationProvider> //,
);

reportWebVitals();
